<section id="nosotros" class="about">
  <div class="container">
      <div class="section-header">
          <h2>Nuestra Historia</h2>
          <div class="divider"></div>
      </div>
      <div class="about-content">
          <div class="about-image">
              <img src="https://lh5.googleusercontent.com/p/AF1QipMzFjlwJdbb1SXvdAEkf6KorwugpteX7TqC4Zy7=w480-h300-k-n-rw" alt="Interior del restaurante Don Chon">
          </div>
          <div class="about-text">
              <h3>Tradición y Sabor desde 2005</h3>
              <p>Fundado por la familia Chen, Don Chon nació con la misión de traer los auténticos sabores de la cocina china tradicional a nuestra ciudad. Nuestros chefs, con más de 25 años de experiencia, preparan cada plato con ingredientes frescos y técnicas ancestrales.</p>
              <p>En Don Chon, no solo ofrecemos comida, sino una experiencia completa que transporta a nuestros comensales a las calles de Beijing, Shanghai y Cantón. Cada detalle, desde la decoración hasta la presentación de los platos, está cuidadosamente pensado para brindar una experiencia auténtica.</p>
              <div class="features">
                  <div class="feature">
                      <div class="feature-icon">🥢</div>
                      <div class="feature-text">Ingredientes Auténticos</div>
                  </div>
                  <div class="feature">
                      <div class="feature-icon">👨‍🍳</div>
                      <div class="feature-text">Chefs Expertos</div>
                  </div>
                  <div class="feature">
                      <div class="feature-icon">🏮</div>
                      <div class="feature-text">Ambiente Acogedor</div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>